




































































































































































































































































































































































































































































































































































































































































































































































































































	import { Vue, BaseTLTableBase, Component, Prop, Vuex, tlISODateToLocalStringForm, EnumsService, EnumsFilter, ObjectTypesHelper, Watch } from "../../Infrastructure/CorBase/CoreBase";
	import { BTable } from 'bootstrap-vue';

    interface iFormDataDay {
        key: string;
        name: string;
        selected: boolean;
    }

    interface iFormDataWeek {
        monday: iFormDataDay;
        tuesday: iFormDataDay;
        wednesday: iFormDataDay;
        thursday: iFormDataDay;
        friday: iFormDataDay;
        saturday: iFormDataDay;
        sunday: iFormDataDay;
    }

	@Component({
		components: {
			Keypress: () => import('vue-keypress')
		}
	})
	export default class BaseTLTableEditable extends BaseTLTableBase {

        @Prop({ type: String, required: false, default: "" }) id?: string; //id

        @Prop({ required: true }) itemsDataHead: any; //zakladni datova napln v headru
		@Prop({ required: true }) itemsData: any; //zakladni datova napln
		@Prop({ required: true }) fields: any;  //jmena sloupců
		@Prop({ required: false }) filters: any;  //filter - seznam filtru a jejich typů
		@Prop({ type: Boolean, required: false, default: true }) sortHeader?: boolean; //seřazení podle nazvu sloupce...pro moznost vypnuti

        @Prop({ type: Boolean, required: false, default: false }) showDetailTask?: boolean; //horní lista co je v taskDetail - kdy se prehrava, audio na pozadí, cas od do, vyjimky

		@Prop({ type: Boolean, required: false, default: true }) isEditableHeadDescription?: boolean; //povoleni menit nazev vlevo nahore v tabulce

        @Prop({ type: Boolean, required: false, default: false }) notUsePerPage?: boolean; //chci vsechny zaznamy - vypnout perPage

		//INFORMACNI PRUH
		@Prop({ type: Boolean, required: false, default: false }) useInfoText?: boolean; //zobrazit - Informační pruh (hlavní)
        @Prop({ type: Boolean, required: false, default: false }) selectInfoText?: boolean; //vybrani zobrazeni - Informační pruh
		@Prop({ required: false }) infoTextFields: any;  //jmena sloupců - Informačního pruhu
		@Prop({ required: false }) infoTextItemsData: any; //zakladni datova napln - Informačního pruhu

		@Prop({ required: false }) gridFields: any; //odkud co namapovat

		@Prop({ type: String, required: false, default: "" }) design?: string; //design - detail, modal (zatim neni nic)
		@Prop({ type: String, required: false, default: "taskDetail" }) designSettingButt!: string; //typ setting button a) taskDetail b) userRole

 		//nové redesign property
        @Prop({ type: Boolean, required: false, default: false }) disabled?: boolean; //disablovani cele tabulky

		@Prop({ type: Boolean, required: false, default: false }) twoBlocks?: boolean; //dva bloky
		@Prop({ type: Boolean, required: false, default: true }) showAddButton?: boolean; //zobrazení nové položky (plusko)
		@Prop({ type: String, required: false, default: "" }) description?: string; //název - TODO dat to povinne
		@Prop({ type: String, required: true, default: "" }) name?: string; //jednoznačny identifator - podle ktereho ukládá stav
		@Prop({ type: Boolean, required: false, default: false }) allowGrid?: boolean; //je možnost přepnout na grid

		@Prop({ type: Boolean, required: false, default: false }) showInModal?: boolean; //zobrazuje se v modalnim okne, pribýva zaviraci ikona

		@Prop({ type: Boolean, required: false, default: false }) selected?: boolean; //možnost vybrat , potřeba dodat
		@Prop({ type: Boolean, required: false, default: false }) selectedMultiHelp?: boolean; //zobrazi se i seznam vsech vybranych, ktery jde odklikavat
		@Prop({ type: Array, required: false }) selectedMultiNames!: string[]; //když je selectedMultiHelp je potreba popsat z ceho se budou skladat ten vyber napr,  { "idPersonNavigationLastname", "idPersonNavigationFirstname" }
	

		@Prop({ type: Boolean, required: false, default: true }) filterSearch?: boolean; //filter viditelnost - vyhledávání
		@Prop({ type: Boolean, required: false, default: true }) filterSearchOn?: boolean; //filter viditelnost - filter podle skupin
		@Prop({ type: Boolean, required: false, default: true }) filterPerPage?: boolean; //filter viditelnost - kolik stránek
		@Prop({ type: Boolean, required: false, default: true }) filterPagination?: boolean; //filter viditelnost - strankovani

		@Prop({ type: String, required: false, default: "" }) buttonDetailName?: string; //vlastní pojmenování tlačítka info
		@Prop({ type: Boolean, required: false, default: false }) buttonDetail?: boolean; //button action - info tlačitko
		@Prop({ type: String, required: false, default: "ÚpravaObs" }) buttonUpdateName?: string; //vlastní pojmenování tlačítka úprava
		@Prop({ type: Boolean, required: false, default: false }) buttonUpdate?: boolean; //button action - update tlačitko
		@Prop({ type: Boolean, required: false, default: false }) buttonDelete?: boolean; //button action - delete tlačitko
		@Prop({ type: String, required: false, default: "" }) buttonDeleteName?: string; //vlastní pojmenování tlačítka smazat
		@Prop({ type: Boolean, required: false, default: false }) buttonOther?: boolean; //button action - update tlačitko
		@Prop({ type: String, required: false, default: "" }) buttonOtherName?: string; //vlastní pojmenování tlačítka smazat
		@Prop({ type: Boolean, required: false, default: false }) simpleTable?: boolean; //schování stránkování

		@Prop({ type: Boolean, required: false, default: true }) fixedMenu?: boolean; //jestli budou vsechny sloupce stejne siroke
		@Prop({ type: Boolean, required: false, default: true }) stickyHeader?: boolean; //pevne dana vyska tabulky, pak se zobrazi linka pod menuhead!!
		@Prop({ type: Array, required: false }) dropDownList!: any[]; //obsah drop down listu

        @Prop({ type: String, required: false, default: "00:00:17" }) minTimeLength?: string; //minimalni delka casu videa (je to v sub nastaveni )

		@Prop({ type: String, required: false, default: "" }) moreActionTitle?: string; //nazev pro hromadnou akci
		@Prop({ type: String, required: false, default: "" }) moreActionTitle2?: string; //nazev pro hromadnou akci 2
		@Prop({ type: String, required: false, default: "" }) moreActionTitle3?: string; //nazev pro hromadnou akci 3
        @Prop({ type: String, required: false, default: "" }) moreActionTitle4?: string; //nazev pro hromadnou akci 4

        @Prop({ type: String, required: false, default: "" }) moreActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka
        @Prop({ type: String, required: false, default: "" }) moreActionIcon2?: string; //jaka ma byt pouzita ikona u tlacitka2
		@Prop({ type: String, required: false, default: "" }) moreActionIcon3?: string; //jaka ma byt pouzita ikona u tlacitka3
        @Prop({ type: String, required: false, default: "" }) moreActionIcon4?: string; //jaka ma byt pouzita ikona u tlacitka4

        @Prop({ type: String, required: false, default: "" }) moreActionIconVariant?: string; //jaka ma byt pouzita varianta green, red
        @Prop({ type: String, required: false, default: "" }) moreActionIconVariant2?: string; //jaka ma byt pouzita varianta green, red
		@Prop({ type: String, required: false, default: "" }) moreActionIconVariant3?: string; //jaka ma byt pouzita varianta green, red
        @Prop({ type: String, required: false, default: "" }) moreActionIconVariant4?: string; //jaka ma byt pouzita varianta green, red

        @Prop({ type: Boolean, required: false, default: true }) moreActionAllow?: boolean; //enabale/disable hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionAllow2?: boolean; //enabale/disable hromadne akce
		@Prop({ type: Boolean, required: false, default: true }) moreActionAllow3?: boolean; //enabale/disable hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionAllow4?: boolean; //enabale/disable hromadne akce

        @Prop({ type: Boolean, required: false, default: true }) moreActionShow?: boolean; //zobrazeni hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionShow2?: boolean; //zobrazeni hromadne akce
		@Prop({ type: Boolean, required: false, default: true }) moreActionShow3?: boolean; //zobrazeni hromadne akce
        @Prop({ type: Boolean, required: false, default: true }) moreActionShow4?: boolean; //zobrazeni hromadne akce

        @Prop({ type: String, required: false, default: "" }) moreActionTooltip?: string; //napoveda k akci
        @Prop({ type: String, required: false, default: "" }) moreActionTooltip2?: string; //napoveda k akci 2
        @Prop({ type: String, required: false, default: "" }) moreActionTooltip3?: string; //napoveda k akci 3
		@Prop({ type: String, required: false, default: "" }) moreActionTooltip4?: string; //napoveda k akci 4

		@Prop({ type: String, required: false, default: "" }) bottomMoreActionTitle?: string; //nazev pro hromadnou akci   - Tlacitko pod tabulkou
        @Prop({ type: Boolean, required: false, default: true }) bottomMoreActionShow?: boolean; //zobrazeni hromadne akce  - Tlacitko pod tabulkou
        @Prop({ type: String, required: false, default: "" }) bottomMoreActionIconVariant?: string; //jaka ma byt pouzita varianta green, red  - Tlacitko pod tabulkou
        @Prop({ type: String, required: false, default: "" }) bottomMoreActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka  - Tlacitko pod tabulkou
        @Prop({ type: Boolean, required: false, default: true }) bottomMoreActionAllow?: boolean; //povoleni hromadne akce  - Tlacitko pod tabulkou
        @Prop({ type: String, required: false, default: "" }) bottomMoreActionTooltip?: string; //tooltip   - Tlacitko pod tabulkou


        @Prop({ type: String, required: false, default: "" }) bottomAddActionTitle?: string; //nazev pro pridani v tabulce   - pro pridani v tabulce 
        @Prop({ type: Boolean, required: false, default: true }) bottomAddActionShow?: boolean; //zobrazeni pro pridani v tabulce  -pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionIconVariant?: string; //jaka ma byt pouzita varianta green, red  - pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionIcon?: string; //jaka ma byt pouzita ikona u tlacitka  - pro pridani v tabulce 
        @Prop({ type: Boolean, required: false, default: true }) bottomAddActionAllow?: boolean; //povoleni hromadne akce  - pro pridani v tabulce 
        @Prop({ type: String, required: false, default: "" }) bottomAddActionTooltip?: string; //tooltip   - - pro pridani v tabulce 

		@Prop({ type: String, required: false, default: "" }) defaultSortBy?: string; //sortBy
		//TODO proč musím použít v LoginHistoryList???
		@Prop({ type: Boolean, required: false, default: true }) isBusyShow?: boolean; //zobrazení spinneru - někde je potřeba použit po fetchi
		@Prop({ type: Boolean, required: false, default: false }) useTagModal?: boolean; //zapnutí možnosti tagů
		@Prop({ type: Number, required: false, default: ObjectTypesHelper.ObjectTypeEnum.Content }) objectType?: ObjectTypesHelper.ObjectTypeEnum;
		//PRESUN
		//selectedAllItems = false;

        isCancelled(data: any) {
            return data.item.isCanceled == true;
		}

        isCancelledText(data: any) {
            return data.item.isCanceled == true ? data.item.idCancelationReasonText : "";
		}

		allowExceptionProp() {           
            return  this.itemsDataHead.isAllowException;
		}

		getCountColumn(columns: any) {
			return String(columns.length);
		}

		prepareIdName() {
			return this.id + "name";
		}

		focusToEditName(id: string) {
            document.getElementById(id)!.focus();
		}


        buttonDetailNameTooltip() {
            return this.buttonDetailName == "" ? this.$t('global.buttonDetailTooltip').toString() : this.buttonDetailName;
        }

        buttonDeleteNameTooltip() {
            return this.buttonDeleteName == "" ? this.$t('global.buttonDeleteTooltip').toString() : this.buttonDeleteName;
		}

        buttonOtherNameTooltip() {
            return this.buttonDeleteName == "" ? this.$t('global.buttonPrintTooltip').toString() : this.buttonDeleteName;
        }

		heightTable = "300px";

		//Testovací pro jeste nepouzite
		helpKey = "testKey";
		helpIndex = "TestIndex";
		helpId = "tt";

		itemsTest = [{ key: 'ci', name: 'Skupina1' }, { key: 'ciS', name: 'Skupina2' }, { key: 'dd', name: 'Skupina3' }];

        week: iFormDataWeek = {
            monday: this.getDay('monday', this.$t('baseTableEditable.day1').toString()),
            tuesday: this.getDay('tuesday', this.$t('baseTableEditable.day2').toString()),
            wednesday: this.getDay('wednesday', this.$t('baseTableEditable.day3').toString()),
            thursday: this.getDay('thursday', this.$t('baseTableEditable.day4').toString()),
            friday: this.getDay('friday', this.$t('baseTableEditable.day5').toString()),
            saturday: this.getDay('saturday', this.$t('baseTableEditable.day6').toString()),
            sunday: this.getDay('sunday', this.$t('baseTableEditable.day7').toString()),
		}

		showException = false;

		testClick(item: any) {
			this.showFilterSetting = false;
		}

		//blockClick nebo blockClickInfoText
		clickBlock(item: any, infoText: boolean) {
			this.$emit('blockClick', this.itemsDataHead, item, infoText);
		}

		getPerPage() {
            return this.notUsePerPage == true ? null : this.perPage;
		}

        getDay(pKey: string, pName: string): iFormDataDay {
            var result: iFormDataDay = {
                key: pKey,
                name: pName,
                selected: true
            }
            return result;
        }

        formData = {
            id: 0,
            key: 'a',
            name: 'NEJAKY popis',
            checked: true,
			week: this.week,
            timeFrom: '00:00',
            timeTo: '23:59'
        }

		private isDesignSetting(type: string) {
			return this.designSettingButt == type;
		}

		showMuteSetting(identifier: string) {
			return identifier == 'ENU_CON_Content_Type_LinkToUrl' ||
				identifier == 'ENU_CON_Content_Type_Audio' ||
				identifier == 'ENU_CON_Content_Type_Video' ||
				identifier == 'ENU_CON_Content_Type_AudioStream' ||
                identifier == 'ENU_CON_Content_Type_HtmlContent';
                }
                
		//zobrazeni checkboxu audio na pozadi
		showAudioCheckBox(data: any) {
			var show = data.item.idContentTypeNavigationIdentifier == "ENU_CON_Content_Type_AudioStream" ||
                data.item.idContentTypeNavigationIdentifier == "ENU_CON_Content_Type_Nothing" ||
                data.item.idContentTypeNavigationIdentifier == "ENU_CON_Content_Type_Audio";
			return show;
        }

		closeSettings() {			
			//kdyz je spusten modalni dialog nechci aby se zavrelo i nastaveni
			this.closeShowSettingActions(1,false);
		}

		public designTypeNotNull(typ: any, name: string) {
			
			var result = this.designType(typ, name);
            if (result) {
                if (typ.value == '') {
                    return false;
                }
            }
            return result
        }

		//NOVE EDITACE - pouze v editacni table

		changeInputItem(item: any) {
			this.$emit('change', item);
		}

		changeInput(item: any) {
			this.anyChange();
		//	this.$emit('change', item.item.order, item.field["key"], item.value);
		}

		get enableSaveSettingMenu() {
			return this._isCorrectDuration;
		}

		validateSaveSettingMenu(item: any): boolean {

			if (item.idContentTypeNavigationIdentifier != 'ENU_CON_Content_Type_LinkToUrl') {
				this._isCorrectRefresh = false;
			}

            if (item.idContentTypeNavigationIdentifier != 'ENU_CON_Content_Type_AudioStream') {
                this._isCorrectBuffer = false;
            }

            return this._isCorrectDuration || this._isCorrectRefresh || this._isCorrectBuffer;
		}

		createUniqueId(name: string, id: string): string {
			return name + id;
		}

		validateStornoSettingManu(): boolean {
			return true;
		}

		_isCorrectDuration = false;
		isCorrectDuration(value: any, id: any) {
			if (('durationEditTable' + this.showSettingOrder) == id) {

				this._isCorrectDuration = !value;
				//TODO tohle by chtelo nahradit COMPUTED
				this.$forceUpdate();
			}
		}

		_isCorrectRefresh = false;
		isCorrectRefresh(value: any, id: any) {
			if (('refreshEditTable' + this.showSettingOrder) == id) {
				this._isCorrectRefresh = !value;
				//TODO tohle by chtelo nahradit COMPUTED
				this.$forceUpdate();
			}
		}

        _isCorrectBuffer = false;
        isCorrectBuffer(value: any, id: any) {		
			if (('bufferEditTable' + this.showSettingOrder) == id) {
                this._isCorrectBuffer = !value;
                //TODO tohle by chtelo nahradit COMPUTED
                this.$forceUpdate();
            }
        }

		saveSettingMenu(id: any, isInfoText: boolean): void {
			if (isInfoText) {
				this.showSettingOrderInfoText = -1;				
				this.showSettingActionInfoText = false;
			}
			else {
                this.showSettingOrder = -1;
                this.showSettingAction = false;
			}
			this.$emit('settingSubMenuSetting', id, isInfoText);
		}

		showSettingAction = true;
        showSettingActionInfoText = true;
		goBackNotChangeSettingMenu(order: any,  isInfoText: boolean): void {
			if (isInfoText) {
				this.showSettingOrderInfoText = -1;
				this.showSettingActionInfoText = false;
			}
			else {
                this.showSettingOrder = -1;
                this.showSettingAction = false;               
			}
			this.$emit('settingSubMenuSettingGoBack', order, isInfoText);
		}

		closeShowSettingActions(order: any, isInfoText: boolean): void {
			if (isInfoText) {
				this.showSettingOrderInfoText = -1;
			}
			else {               
                this.showSettingOrder = -1;
			}
			this.$emit('settingSubMenuSettingGoBack', order, isInfoText);
		}

		oldException = '';
		openExceptionMenu() {
			this.oldException = JSON.parse(JSON.stringify(this.itemsDataHead.exceptionText));
            this.showException = true;
		}

		closeExceptionMenu() {
            this.itemsDataHead.exceptionText = JSON.parse(JSON.stringify(this.oldException));
			this.showException = false;
		}

		saveException() {
			this.showException = false;
			this.anyChange();
		}

		menuSettingStyle(): string {
			let id = 'settingButton' + this.showSettingOrder;
			let htmlElement = document.getElementById(id);
			let top: number = 0;
			let left: number = 0;
			if (htmlElement) {
				let offsets: DOMRect = htmlElement.getBoundingClientRect();
				if (this.showSettingOrder != -1 && offsets) {					
					top = offsets.top;
					left = offsets.right;
					left = left - 400;
					top = top + 310;
					top = 750 + this.showSettingIndex * 85;
				}
			}
			return 'left: ' + left + 'px; top: ' + top + 'px;';
		}

		settingClick(item: any, isInfoText: boolean): void {
			if (isInfoText) {
				this.showSettingOrderInfoText = item.item.order == undefined ? item.index : item.item.order;
			}
			else {
				this.showSettingOrder = item.item.order == undefined ? item.index : item.item.order;
			}
            this.showSettingIndex = item.index;
            this.showSettingActionInfoText = isInfoText;		
            this.showSettingAction = !isInfoText;		
			this.$emit('startSettingMenu', item);
		}

		anyChange() {
            this.$emit('anyChange', this.itemsDataHead.id);
        }

		changeCheckbox(item: string) {
            this.$emit('changeCheckboxHead', item, this.itemsDataHead.id);
		}

		changeCheckboxTable(id: any,indexHelp: any, keyHelp: any) {
			this.$emit('changeCheckbox', id, indexHelp, keyHelp, this.itemsDataHead.id);
		}
		       
        changeCheckboxListHead(dayKey: any, indexHelp: any, keyHelp: any) {

			this.$emit('changeCheckboxListHead', dayKey, indexHelp,keyHelp, this.itemsDataHead.id);
		}

		changeCheckboxList(dayKey: any, indexHelp: any, keyHelp: any) {		
			this.$emit('changeCheckboxList', dayKey, indexHelp, keyHelp);
		}	
		changeListItem(item: any) {
		}
	
		color = 'neco';
        showSettingOrderInfoText = -1;
		showSettingOrder = -1;
		showSettingIndex = 0;

		moveUp(item: any, isInfoText:boolean): void {
            this.$emit('moveUp', item.item.order, this.itemsDataHead.id, isInfoText);
		}

        moveDown(item: any, isInfoText: boolean): void {
            this.$emit('moveDown', item.item.order, this.itemsDataHead.id, isInfoText);
		}

		//END NOVE EDITACE


		get isContentObjectType(): boolean {
			return ObjectTypesHelper.isContentObjectType(this.objectType);
		}

		get isTaskPartObjectType(): boolean {
			return ObjectTypesHelper.isTaskPartObjectType(this.objectType);
		}

		get isReceiverObjectType(): boolean {
			return ObjectTypesHelper.isReceiverObjectType(this.objectType);
		}

		//TODO udelat lepe - na dvou mistech
		prepareIdBasePreview(data: any) {
			if (data == null) {
				return 0;
			}
			return data;
		}

		getPreviewId(id: number | null | undefined): string {
			if (id && id > 0) {
				if (this.isContentObjectType) {
					return `image_table_content_${id}`;
				}
				// TaskPart zobrazuje nahled na obrazek, ale id musi brat z jineho pole, nicmene ostatni veci vcetne cachovani jsou stejne
				if (this.isTaskPartObjectType) {
					return `image_table_content_${id}`;
				}
				if (this.isReceiverObjectType) {
					return `image_table_receiver_${id}`;
				}
			}
			return `image_popup_0`;
		}

		//zobrazeni listy s vybranymi filry
		showSelectedFilterBlock(): boolean {
			return (this.filterData as Array<any>).filter(c => (c.selected && !c.isNegative) || (!c.selected && c.isNegative) || (c.selected && c.useEnum)).length > 0;
		}

		//tady tohle podbarví vybraný řádek
		rowClassSelected(item: any): string {
			if (item != undefined && this.selectedRowMain.indexOf(item.id) > -1) {
				return 'tableRowSelected';
			}
			else {
				return '';
			}
		}

		//kvuli zmizení nabídky filtrů
		clickAnyWhere() {

			if (this.showFilterSetting) {
				this.showFilterSetting = false;
			}
		}

		closeWindow(): void {
			this.$emit('close', true);
		}

		//TODO je to správná cesta??? nezpomaluje to??
		designType(typ: any, name: string) {
			if (name == '' && typ.field['design'] == undefined) {
				return true;
			}
			else if (typ.field['design'] == name) {
				return true;
			}
			else {
				return false;
			}

		}

        bottomMoreAction() {
            this.$emit('bottomMoreAction', this.selectedRowMain);
        }

		moreAction() {
			this.$emit('moreAction', this.selectedRowMain);
		}

		moreAction2() {
			this.$emit('moreAction2', this.selectedRowMain);
		}
		
		moreAction3() {
            this.$emit('moreAction3', this.selectedRowMain, this.itemsDataHead);
		}

        moreAction4() {
            this.$emit('moreAction4', this.selectedRowMain, this.itemsDataHead);
        }

		//hack aby nedoslo k dvojimu zavolani...
		lastCheck = '';
		changeClick(id: any, checked: any) {
			let newChecked = id + checked;
			if (this.lastCheck != newChecked) {
				this.lastCheck = newChecked;
				this.$emit('changeCheck', id);
			}
		}
		lastCheck2 = '';
		changeClick2(id: any, checked: any) {
			let newChecked = id + checked;
			if (this.lastCheck2 != newChecked) {
				this.lastCheck2 = newChecked;
				this.$emit('changeCheck2', id);
			}
		}

		addNew() {
			this.$emit('addNew');
		}

		addButtonClick(id: any) {
			this.$emit('addButtonClick', id);
		}

		changeDropDownList(item: any, clickEvent: any, idRow: any) {
			item = clickEvent;
			this.$emit('changeDropDownList', { idCar: clickEvent, id: idRow });
		}

		//nastavení ikony podle W- wait, S - success, E- error
		showIconBy(item: any, position: number, type: string): boolean {
			return item[position] == type;
		}


		//nachystani toolTipu
		initTooltipColumns() {
			this.tooltipsColumns = [];
			for (var i = 0; i < this.fields.length; i++) {
				if (this.fields[i].tooltip != undefined) {
					this.tooltipsColumns.push({ text: this.fields[i].key, value: this.fields[i].tooltip });
				}
			}
			this.useTooltip = this.tooltipsColumns.length > 0;
		}

		showToolTipIcon(data: any) {
			return this.tooltip(data).split('\n').length > 2;
		}

		tooltip(data: any) {
			var result = '';
			var findInToolTip = this.tooltipsColumns.find(c => c.text == data.field.key);
			if (findInToolTip != undefined) {
				Object.keys(data.item).forEach(key => {
					if (key == findInToolTip.value) {
						result = data.item[key];
					}
				});
			}
			return result;
		}

		change(event: any[]) {

			let differenceAdd = event.filter(x => this.selectedColumnsVisibility.indexOf(x.toString()) === -1);
			let diferenceRemove = this.selectedColumnsVisibility.filter(x => event.indexOf(x.toString()) === -1);

			if (diferenceRemove.length > 0) {
				this.changeVisibility(diferenceRemove[0], false);
				this.selectedColumnsVisibility.splice(this.selectedColumnsVisibility.indexOf(diferenceRemove[0], 1));
			}
			if (differenceAdd.length > 0) {
				this.changeVisibility(differenceAdd[0], true);
				this.selectedColumnsVisibility.push(differenceAdd[0]);
			}
		}

		changeVisibility(name: string, isVisible: boolean) {
			let field = this.fields.filter((c: any) => c.key == name)[0];
			if (name == '') {
				return;
			}

			if (isVisible) {
				if (field.class.indexOf('visibility') != -1) {
					field.class = field.class.replace('collapse', 'visible');
				}
				else {
					field.class = field.class + ' , visibility: visible';
				}
			}
			else {
				if (field.class.indexOf('visibility') != -1) {
					field.class = field.class.replace('visible', 'collapse');
				}
				else {
					field.class = field.class + ' , visibility: collapse';
				}
			}
		}

		getFilters() {
			var allowFilter = [];
			if (this.filters != null) {
				var filtersNotGroup = (this.filters as Array<any>).filter(c => c.group == false || c.group == undefined);
				for (var i = 0; i < filtersNotGroup.length; i++) {
					if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem).length > 0) {

						if (this.fields.filter((c: any) => c.key == filtersNotGroup[i].key || c.key === filtersNotGroup[i].refItem)[0].class.indexOf('collapse') > -1) {
							filtersNotGroup[i].selected = false;
						} else {
							allowFilter.push(filtersNotGroup[i]);
						}
					}
				}
			}
			return allowFilter;
		}

		showButtonDelete(data: any) {
			if (this.onlyShow) {
				return false;
			}
			if (data != undefined) {
				return this.buttonDelete && (data as boolean) == true;
			}
			return this.buttonDelete;
		}

		isLoading() {
			return this.isBusy && this.isBusyShow;
		}

		showButtonUpdate(data: any) {
			if (this.onlyShow) {
				return false;
			}
			if (data != undefined) {
				return this.buttonUpdate && (data as boolean) == true;
			}
			return this.buttonUpdate;
		}

		//tady se to rozděli pomoci značky  #a#
		prepareDataColumn(data: any) {
			if (data) {
				let sData: string = String(data)
				if (sData.length > 0) {
					return sData.split('#a#');
				}
			}
			return null;
		}

		columnColor(color: string): string {
			return 'background-color: ' + color + ';' + ' color: ' + color + ';';
		}

		removeItem(selectedOption: any) {
			this.clickRow(selectedOption.id, false);
		}

		//zatím je výběr více řádků
		get selectMode() {
			return 'multi';
		}

		//změna jakehokoliv filtru
		changeFilter(id: any) {
			this.isBusy = true;
			this.filterItems();
			this.isBusy = false;
		}

		/**zapnuti filtru*/
		clickFilterOn(key: string) {
			var filter = (this.filters as Array<any>).filter(c => c.key == key)[0];
			filter.selected = !filter.selected;
			if (filter.selected) {
				let id = filter!.key
				this.$nextTick(() => {
					document.getElementById(id)!.focus();
				})
			}
			else {

				if (filter.group == undefined) {
					filter.value = '';
				}
			}
			this.isBusy = false;
		}

		fieldsPlusSel: any[] = [];
		fieldsItems() {
			if (this.fieldsPlusSel.length == 0) {
				let actionField = (this.fields as Array<any>).filter(c => c.key == 'actions')[0];

				if (actionField != undefined && actionField.class == undefined) {
					actionField.class = 'width140';		 //defaultni nastaveni
					if (actionField.label == undefined) {
						actionField.label = '';
					}
				}
				if (this.selected) {
					this.fieldsPlusSel.push({ key: 'selected', label: '', sortable: false, class: 'columnSelected ', optional: false });
					for (var i = 0; i < this.fields.length; i++) {
						this.fieldsPlusSel.push(this.fields[i]);
					}
				}
				else {
					this.fieldsPlusSel = this.fields;
				}
			}
			return this.fieldsPlusSel;
		}

		//počet všechn záznamů a aktuální stránka
		sumaryAllItemsText() {
			let result = this.totalRows;
			let start = (this.currentPage - 1) * this.perPage + 1;
			let end = (this.currentPage) * this.perPage;
			if (end > this.totalRows) {
				end = this.totalRows;
			}

			if (this.totalRows == 0) {
				return 'žádné záznamy';
			}
			return start + '-' + end + '/' + result;
		}

		//zobrazení ikon na hlavní liste vpravo
		showIconFilters(): boolean {
			return this.getFilters().length > 0 && !this.showFilterSetting;
		}

		showIconClose(): boolean {
			const modalShow = this.showInModal == undefined ? false : this.showInModal;
			return modalShow && !this.showFilterSetting;
		}

		showIconColumnSetting(): boolean {
			return this.optionsColumns.length > 0 && !this.isGridShow;
		}

		showIconGrid(): boolean {
			return this.allowGrid == true;
		}

		showIconTable(): boolean {
			return this.allowGrid == true;
		}

		showIconSeparate(): boolean {
			return this.allowGrid == true && (this.showIconFilters() || this.showIconColumnSetting()) && (this.showIconGrid() || this.showIconTable());
		}

		detailClick(id: number): void {
			this.$emit('clickDetail', id);
		}

		actionDelete(row: any) {
			if (row.item.id == undefined) {
				this.$emit('clickDelete', row.item, this.itemsDataHead.id);
			}
			else {
                this.$emit('clickDelete', row.item.id, this.itemsDataHead.id);
			}
		}
		//když nechci jen prosté ID
		actionOther(item: any) {
			this.$emit('clickOther', item);
		}

		//vlastní definované tlačítko
		actionOwnButton(action: any, isSingleRow: boolean, item: any) {
			if (isSingleRow) {
				this.$emit(action, item);
			}
			else {
				this.$emit(action, this.selectedRowMain);
			}
		}

		rowDblClick(id: any) {
			this.$emit('clickRow', id);
		}

		get inputClassHead() {
			return {
				"tabMenu": this.design == '',
				"tabMenuDetail": this.design == 'detail'
			};
		}

		get inputClassHeadDescription() {
			return {
				"tabMenuDescription": this.design == '',
				"tabMenuDescriptionDetail": this.design == 'detail'
			};
		}

		get inputClassHeadAddIcon() {
			return {
				"iconsAddNew": this.design == '',
				"iconsAddNewDetail": this.design == 'detail'
			};
		}

		filterItems() {
			return super.filterItems();
		}

		clickRow(id: any, isClick: boolean) { super.clickRow(id, isClick); }

		contextChange() {			super.contextChange;	}

		headClicked(key: any) {
			if (this.sortHeader == true) {
				this.sortBy = key;
			}
		}

		sortChanged() { super.sortChanged(); }

		getFiltersByGroupsForShow() { return super.getFiltersByGroupsForShow(); }

		useFilters() {return super.useFilters();		}

		created() {
			this.initBaseProperties();
			super.created();
		}

		beforeUpdate() {
			super.beforeUpdate();
		}

		initBaseProperties() {
			this.fieldsBase = this.fields;
			this.filtersBase = this.filters;
			this.selectedBase = this.selected == null? false: this.selected;
			this.itemsDataBase = this.itemsData;



			this.selectedMultiNamesBase = this.selectedMultiNames;
			this.nameBase = this.name == null ? '' : this.name;
			this.designBase = this.design == null ? '' : this.design;
			this.defaultSortByBase = this.defaultSortBy == null ? '' : this.defaultSortBy;
		}

		initItemsData(): void {
			this.itemsDataBase = this.itemsData;
		}

		@Watch('itemsData')
		itemsDataChanged(value: string, oldValue: string) {
			if (value !== oldValue) {
				this.initItemsData();
				//TODO nevim proc to nenacte jak ma
				this.$forceUpdate();
			}
		}
				
        @Watch('itemsDataHead')
        itemsDataHeadChanged(value: string, oldValue: string) {
            if (value !== oldValue) {
                this.initItemsData();
                //TODO nevim proc to nenacte jak ma
                this.$forceUpdate();
            }
        }

		@Watch('fields')
		fieldsDataChanged(value: string, oldValue: string) {
			if (value !== oldValue) {
				this.fieldsBase = this.fields;
			}
		}

		@Watch('filters')
		filtersDataChanged(value: string, oldValue: string) {
			if (value !== oldValue) {
				this.filtersBase = this.filters;

			}
		}

        @Watch('perPage')
        onPropertyChangedPerPage(value: number, oldValue: number) {         
        }

        @Watch('currentPage')
        onPropertyChangedCurrentPage(value: number, oldValue: number) {
          
        }

		getItemsBlock(item: any) {
			var result = this.filterItems();
            if (this.twoBlocks) {
				if (item == 1) {
                    return result.filter((c: any) => c.inTheBackground == false );
				}
				else {
                    return result.filter((c: any) => c.inTheBackground == true);
				}
			}
			else {
				return result;
			}
		}
				 
		//kdyz to chceme na dva bloky
		getShowTwoTable() {    

			if (this.twoBlocks)
			{
				return [1, 2];
			}
			else {
				return [1];
			}
		}

		getFiledsBlock(item: number,fields: any) {
			var result = fields;
            if (this.twoBlocks) {
				var resultFilter = result.filter((c: any) => c.showOn == undefined || c.showOn == item);
					return resultFilter;
			}
			else {

                result = result.filter((c: any) => c.showOn == undefined || c.showOn == 1 );
				return result;
			}	
		}

	}
